module.exports = __webpack_public_path__ + "img/fullscreen-icon.0b9ce491.svg";